import { motion } from "framer-motion";
import { Star } from "lucide-react";
import TESTIMONIALS, { REVIEW_AGGREGATE } from "@/data/testimonialsData";

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative py-14 md:py-32 overflow-hidden"
    >
      <div className="aurora-soft" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-10 md:mb-14 gap-6">
          <div className="max-w-2xl">
            <div className="text-[10px] font-mono-acc uppercase tracking-[0.3em] text-cyan-400 mb-3">
              / Founder feedback
            </div>
            <h2 className="font-clash text-3xl md:text-5xl font-semibold tracking-tight leading-[1.05]">
              Trusted by operators who <span className="text-gradient-neon">don't tolerate fluff.</span>
            </h2>
            <p className="mt-3 text-xs text-zinc-500 max-w-md leading-relaxed">
              Live client outcomes from active and recently-completed engagements
              across UAE, KSA, and the wider GCC. Reference calls available for
              qualified prospects.
            </p>
          </div>
          <div className="flex items-center gap-2 text-sm text-zinc-400">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star
                  key={i}
                  size={14}
                  className={i < Math.round(REVIEW_AGGREGATE.rating) ? "fill-cyan-400 text-cyan-400" : "text-zinc-700"}
                />
              ))}
            </div>
            {REVIEW_AGGREGATE.rating} / 5 across {REVIEW_AGGREGATE.count}+ {REVIEW_AGGREGATE.label}
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.55, delay: (i % 3) * 0.08 }}
              className="relative rounded-3xl glass-strong p-7 ring-glow"
              data-testid={`testimonial-${i}`}
            >
              <div className="absolute top-0 left-7 right-7 h-px bg-gradient-to-r from-transparent via-cyan-400/60 to-transparent" />
              <div className="flex mb-5">
                {[...Array(5)].map((_, k) => (
                  <Star key={k} size={13} className="fill-cyan-300/90 text-cyan-300/90" />
                ))}
              </div>
              <blockquote className="text-zinc-200 text-[15px] leading-relaxed">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-7 flex items-center gap-3">
                <div className="h-11 w-11 rounded-full bg-gradient-to-br from-cyan-500/30 to-purple-500/30 border border-white/10 flex items-center justify-center font-clash text-sm text-white">
                  {(t.name || "?").charAt(0)}
                </div>
                <div>
                  <div className="font-clash text-sm font-medium text-white">{t.name}</div>
                  <div className="text-xs text-zinc-500">{t.role}</div>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>

        <p className="mt-10 text-center text-[11px] text-zinc-500 italic">
          Per UAE Consumer Protection Law, we publish testimonials only with written
          client consent. Anonymised quotes here represent real engagements.
        </p>
      </div>
    </section>
  );
}
